import { render, staticRenderFns } from "./EditAnnouncement.vue?vue&type=template&id=ed19a4fe&scoped=true&"
import script from "./EditAnnouncement.vue?vue&type=script&lang=js&"
export * from "./EditAnnouncement.vue?vue&type=script&lang=js&"
import style0 from "./EditAnnouncement.vue?vue&type=style&index=0&id=ed19a4fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed19a4fe",
  null
  
)

export default component.exports